import clsx from 'clsx';
import type { OwnerMode } from '@/lib/owner';

/** "Mine / Everyone" toggle shown above tests and run reports. */
export function OwnerFilter({
  value,
  onChange,
  mineCount,
  allCount,
  mineLabel = 'Mine',
}: {
  value: OwnerMode;
  onChange: (mode: OwnerMode) => void;
  mineCount: number;
  allCount: number;
  mineLabel?: string;
}) {
  const options: { id: OwnerMode; label: string; count: number }[] = [
    { id: 'mine', label: mineLabel, count: mineCount },
    { id: 'all', label: 'Everyone', count: allCount },
  ];
  return (
    <div role="group" aria-label="Show items from" className="inline-flex rounded-xl bg-slate-100 p-1 dark:bg-slate-800/80">
      {options.map((o) => (
        <button
          key={o.id}
          type="button"
          aria-pressed={value === o.id}
          onClick={() => onChange(o.id)}
          className={clsx(
            'inline-flex items-center gap-1.5 rounded-lg px-3 py-1 text-xs font-medium transition',
            value === o.id
              ? 'bg-white text-slate-900 shadow-soft dark:bg-slate-900 dark:text-white'
              : 'text-slate-600 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white',
          )}
        >
          {o.label} <span className="opacity-70">{o.count}</span>
        </button>
      ))}
    </div>
  );
}
